/**
 * Created by dx.yang on 2017/3/20.
 */


import * as commonConst from '../common/constants';
import * as imageConst from './constants';
import * as imageApis from '../../services/apis/image';
import Vue from 'vue';

export default {
    [imageConst.getImages](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.DescribeImages);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(imageConst.getImages, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [imageConst.getImagesSilence](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.DescribeImages);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [imageConst.modifyName](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.ModifyImageName);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.removeImages](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.RemoveImages);
            console.log('remove images', params);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);

                data = _.get(data, 'result[0].ReturnSet');

                if (_.every(data, function (item) {
                        return item.Return == true
                    })) {
                    resolve();
                } else {
                    let errorArray = _.map(_.filter(data, function (item) {
                        return item.Return == false
                    }), 'ImageId');
                    reject(errorArray + ' ' + Vue.$trans(`删除失败`))
                }
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.CheckHasIamRole](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.CheckHasIamRole);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.imagePlatforms](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.imagePlatforms);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },

    [imageConst.validateImportimg](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.validateImportimg);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.importImages](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.importImages);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.getQutainfos](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.getQutainfos);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.copyImages](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.copyImages);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.switchImageType](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.switchImageType);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.warmUpCustomImage](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.warmUpCustomImage);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.cancelWarmUpCustomImage](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.cancelWarmUpCustomImage);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.getcopyRegions](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.getcopyRegions);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.getshareAccounts](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.getshareAccounts);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.shareImages](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.shareImages);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.DescribeImagesByTagValue](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.DescribeImagesByTagValue);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.DescribeLocalImageQuotaAndCount](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.DescribeLocalImageQuotaAndCount);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.DescribeKs3ServiceStatus](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.DescribeKs3ServiceStatus);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.QueryWhiteList](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.QueryWhiteList);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.QueryBuckets](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.QueryBuckets);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.ExportImage](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.ExportImage);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.CancelImageExport](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.CancelImageExport);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.ImageAccelerate](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.ImageAccelerate);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.IsUserSupportImageAccelerate](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.IsUserSupportImageAccelerate);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
    [imageConst.ModifyImageAttribute](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, imageApis.ModifyImageAttribute);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
};

